import {
  pgTable,
  serial,
  text,
  timestamp,
  varchar,
  boolean,
  real,
  integer
} from "drizzle-orm/pg-core"
import { relations } from "drizzle-orm"
import { usersTable } from "./Users"

export const organizationsTable = pgTable("Organizations", {
  id: serial().primaryKey(),
  creationTimestamp: timestamp({ withTimezone: true }).defaultNow(),
  blockTimestamp: timestamp({ withTimezone: true }).defaultNow(),
  lastEditTimestamp: timestamp({ withTimezone: true }).defaultNow(),
  name: varchar({ length: 255 }).notNull(),
  description: text().notNull().default(""),
  blocked: boolean().notNull().default(false),
  deleted: boolean().notNull().default(false),

  // AI SETTINGS
  systemPrompt: text().notNull().default(""),
  userPrompt: text().notNull().default(""),
  aiMaxTokens: integer(),
  aiTemperature: real().$type<number | null>()
})

export const organizationsRelations = relations(
  organizationsTable,
  ({ many }) => ({
    users: many(usersTable),
  }),
)

export type OrganizationSchema = typeof organizationsTable.$inferSelect
export type NewOrganizationSchema = typeof organizationsTable.$inferInsert
